/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Open360ShopperApiContractV18MeasurementsSizeListItem } from './open360ShopperApiContractV18MeasurementsSizeListItem';


export interface Open360ShopperApiContractV18MeasurementsMeasurementListItem {
    /**
     * 1 = Neck, 2 = Chest, 3 = Bust, 4 = Waist, 5 = Hips, 6 = InsideLeg, 7 = Shoe, 8 = LegLength, 9 = Dress
     */
    Type?: Open360ShopperApiContractV18MeasurementsMeasurementListItem.TypeEnum;
    Sizes?: Array<Open360ShopperApiContractV18MeasurementsSizeListItem>;
}
export namespace Open360ShopperApiContractV18MeasurementsMeasurementListItem {
    export type TypeEnum = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
    export const TypeEnum = {
        NUMBER_1: 1 as TypeEnum,
        NUMBER_2: 2 as TypeEnum,
        NUMBER_3: 3 as TypeEnum,
        NUMBER_4: 4 as TypeEnum,
        NUMBER_5: 5 as TypeEnum,
        NUMBER_6: 6 as TypeEnum,
        NUMBER_7: 7 as TypeEnum,
        NUMBER_8: 8 as TypeEnum,
        NUMBER_9: 9 as TypeEnum
    }
}



// WEBPACK FOOTER //
// ./src/app.retailer/modules/model/open360ShopperApiContractV18MeasurementsMeasurementListItem.ts